// Edite aqui nome, preços e links de checkout.
export const SITE = {
  name: "Pedagogia Digital OFC",
  tagline: "Acervo pedagógico para revenda",
  kitPrice: 19.9,
  basic: { old: "R$ 67,00", price: "10", cents: ",00", label: "R$10" },
  premium: { old: "R$ 197,00", price: "27", cents: ",90", save: "Economize R$ 169,10" },
  upsell: { extra: "+ R$ 9,90", total: "R$ 19,90", label: "+R$9,90" },
  checkout: {
    premium: "[LINK_CHECKOUT_PREMIUM]",
    upsellPremium: "[LINK_CHECKOUT_UPGRADE_PREMIUM]",
    basic: "[LINK_CHECKOUT_BASICO]",
  },
};

export const isPlaceholder = (url) => !url || url.startsWith("[");
